import { cn } from '@/core/utils/common'

export type StudioItemStatus = {
  label: string
  title?: string
  tone: 'draft' | 'ready' | 'published'
}

const DOT: Record<StudioItemStatus['tone'], string> = {
  draft: 'bg-point',
  ready: 'bg-ok',
  published: 'bg-foreground',
}

/** 목록과 선택 화면의 상태 — 상자 없이 점 + 글자 한 줄. 색은 점에만 둬서 제목보다 튀지 않게 */
export default function StudioStatusBadge({
  status,
}: {
  status: StudioItemStatus
}) {
  return (
    <span
      title={status.title}
      className="inline-flex max-w-full min-w-0 shrink-0 items-center gap-1.5 text-c12 leading-5 font-medium text-gray over10:text-c14"
    >
      <span
        aria-hidden="true"
        className={cn('size-1.5 flex-none rounded-full', DOT[status.tone])}
      />
      <span className="truncate">{status.label}</span>
    </span>
  )
}
